<template>
  <div id="db-table-edit">
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
    <WriteSqlModal ref="WriteSqlModal" v-on:complete="writeSQLComplete"></WriteSqlModal>
    <Modal title="枚举值" v-model="enumValueModal" @on-cancel="enumValueModalCancel" @on-ok="enumValueOk">
      <Row v-for="(item, index) in enumValues" style="margin-bottom: 10px" :key="'enumValues_' + index">
        <Input placeholder="请输入" v-model="item.value" style="width: 200px" size="small"/>
        <Tooltip content="移除" style="line-height: 22px">
          <a v-on:click="removeEnumValue(index)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>
        </Tooltip>
      </Row>
      <Row style="margin-top: 10px">
        <a v-on:click="addEnumValue()">增加</a>
      </Row>
    </Modal>
    <Modal title="包含列" v-model="indexHaveColumnsModal" @on-cancel="indexHaveColumnsModalCancel" @on-ok="indexHaveColumnsOk">
      <!--<Row>-->
        <!--<span style="width: 200px; display: block; float: left; padding-left: 5px">列名</span>-->
        <!--<span style="width: 70px; display: block; float: left; padding-left: 5px">子部分</span>-->
      <!--</Row>-->
      <Row v-for="(item, index) in indexHaveColumns" style="margin-bottom: 10px" :key="'indexHaveColumns_' +index">
        <Select filterable clearable v-model="item.column" style="width: 200px; margin-right: 5px" size="small" placeholder="列名">
          <Option
            v-for="(columnNameItem, columnNameItemIndex) in table.columns"
            v-if="columnNameItem.name"
            :key="'columnNameItemIndex_' + index + '_' + columnNameItemIndex"
            :value="columnNameItem.name">{{ columnNameItem.name }}</Option>
        </Select>
        <Input placeholder="子部分" v-model="item.son" style="width: 70px" size="small"/>
        <Tooltip content="移除" style="line-height: 22px">
          <a v-on:click="removeIndexHaveColumn(index)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>
        </Tooltip>
      </Row>
      <Row style="margin-top: 10px">
        <a v-on:click="addIndexHaveColumn()">增加</a>
      </Row>
    </Modal>
    <Alert v-if="error" show-icon type="error">获取数据失败<a style="float: right" v-on:click="resetForm">重新获取</a></Alert>
    <Form :label-width="60" ref="tableForm" :model="table" inline :rule="tableRule" v-else>
      <a v-on:click="control.baseInfo = !control.baseInfo">
        <Divider orientation="left" dashed>
          <span>基本信息 </span>
          <Icon :type="control.baseInfo ? 'ios-arrow-down' : 'ios-arrow-forward'" />
        </Divider>
      </a>
      <div v-show="control.baseInfo" class="info-edit-form-content">
        <FormItem label="表名" prop="name">
          <Input v-model="table.basis.name" style="width: 150px"/>
        </FormItem>
        <FormItem label="注释">
          <Input v-model="table.basis.remark" style="width: 150px"/>
        </FormItem>
        <Row>
          <FormItem label="存储引擎">
            <Select v-model="table.basis.storage_engine" style="width: 150px" transfer filterable>
              <Option v-for="item in storage_engine_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="字符集">
            <Select v-model="table.basis.character" style="width: 150px" transfer filterable
                    @on-change="v => {getCharacterCollateListByCharacter(v, true)}">
              <Option v-for="item in characterList" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="校验规则">
            <Select v-model="table.basis.verify_rule" style="width: 150px" transfer filterable>
              <Option v-for="item in characterCollateList" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="行格式">
            <Select v-model="table.basis.row_format" style="width: 150px" transfer filterable>
              <Option v-for="item in row_format_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Row>
      </div>
      <a v-on:click="control.columnsInfo = !control.columnsInfo">
        <Divider orientation="left" dashed>
          <span>列信息 </span>
          <Icon :type="control.columnsInfo ? 'ios-arrow-down' : 'ios-arrow-forward'" />
        </Divider>
      </a>
      <div v-show="control.columnsInfo" class="info-edit-form-content">
        <Table
          ref="columnsTable"
          border
          highlight-row
          size="small"
          :data="table.columns"
          :columns="tableCC">
          <template slot="name" slot-scope="props">
            <Input v-model="props.row.name" size="small" />
          </template>
          <template slot="type" slot-scope="props">
            <Select placeholder="" filterable v-model="props.row.type" size="small" transfer>
              <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </template>
          <template slot="length" slot-scope="props">
            <Input v-model="props.row.length" size="small" />
          </template>
          <template slot="gen_default" slot-scope="props">
            <Input v-model="props.row.default" size="small"/>
          </template>
          <template slot="dis_default" slot-scope="props">
            <Input v-model="props.row.default" size="small" disabled/>
          </template>
          <template slot="date_default" slot-scope="props">
            <Select v-model="props.row.default" size="small" placeholder="选择默认值" clearable>
              <Option value="Empty String">Empty String</Option>
              <Option value="CURRENT_TIMESTAMP">CURRENT_TIMESTAMP</Option>
            </Select>
          </template>
          <template slot="remark" slot-scope="props">
            <Input v-model="props.row.remark" size="small" />
          </template>
          <template slot="is_null" slot-scope="props">
            <i-switch v-model="props.row.is_null" :disabled="props.row.primary_key">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </template>
          <template slot="primary_key" slot-scope="props">
            <i-switch v-model="props.row.primary_key" @on-change="v=>{ primarySwitch(v, props.idx) }">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </template>
          <template slot="removeColumnField" slot-scope="props">
            <Poptip
              transfer
              confirm
              placement="bottom"
              title="确定要移除当前字段吗？"
              @on-ok="removeColumnField(props.idx)">
              <a>移除</a>
            </Poptip>
          </template>
          <template slot="type_tinyint" slot-scope="props">
            <Form :label-width="60">
              <FormItem label="自动增长">
                <i-switch v-model="props.row.more.auto_increment">
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </i-switch>
              </FormItem>
              <FormItem label="ZEROFILL">
                <i-switch v-model="props.row.more.zerofill">
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </i-switch>
              </FormItem>
            </Form>
          </template>
          <template slot="type_float" slot-scope="props">
            <Form :label-width="60">
              <FormItem label="小数点">
                <Input style="width: 100px" v-model="props.row.more.decimal_point" size="small"/>
              </FormItem>
              <FormItem label="ZEROFILL">
                <i-switch v-model="props.row.more.zerofill">
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </i-switch>
              </FormItem>
            </Form>
          </template>
          <template slot="type_enum" slot-scope="props">
            <Form :label-width="60">
              <FormItem label="值">
                <Input v-model="props.row.more.value" style="width: 300px; margin-right: 5px" size="small"/>
                <Button type="default" size="small" @click="openEnumModal(props.idx)">...</Button>
              </FormItem>
            </Form>
          </template>
          <template slot="type_time" slot-scope="props">
            <Form :label-width="140">
              <FormItem label="根据当前时间戳更新">
                <i-switch v-model="props.row.more.on_update_current_time">
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </i-switch>
              </FormItem>
            </Form>
          </template>
        </Table>
        <Row style="margin-top: 10px">
          <Divider>
            <a v-on:click="addColumnField" style="font-size: 14px">增加列</a>
          </Divider>
        </Row>
      </div>
      <a v-on:click="control.index = !control.index">
        <Divider orientation="left" dashed>
          <span>索引 </span>
          <Icon :type="control.index ? 'ios-arrow-down' : 'ios-arrow-forward'" />
        </Divider>
      </a>
      <div v-show="control.index" class="info-edit-form-content">
        <Table
          id="indexTable"
          ref="indexTable"
          border
          highlight-row
          size="small"
          :data="table.index"
          :columns="index.columns">
          <template slot="name" slot-scope="props">
            <Input v-model="props.row.name" size="small" />
          </template>
          <template slot="columns" slot-scope="props">
            <Input v-model="props.row.columns" size="small" disabled>
            <a slot="append" v-on:click="openIndexHaveColumnsModal(props.idx)" style="font-size: 8px">编辑</a>
            </Input>
            <!--<Button type="default" size="small" @click="openIndexHaveColumnsModal(props.idx)">...</Button>-->
          </template>
          <template slot="type" slot-scope="props">
            <Select v-model="props.row.type" size="small" placeholder="">
              <Option value="Normal">Normal</Option>
              <Option value="Unique">Unique</Option>
              <Option value="Full Text">Full Text</Option>
            </Select>
          </template>
          <template slot="func" slot-scope="props">
            <Select v-model="props.row.func" size="small" placeholder="">
              <Option value="BTREE">BTREE</Option>
              <Option value="HASH">HASH</Option>
            </Select>
          </template>
          <template slot="removeIndexRow" slot-scope="props">
            <Poptip
              transfer
              confirm
              placement="bottom"
              title="确定要移除当前索引吗？"
              @on-ok="removeIndexRow(props.idx)">
              <a>移除</a>
            </Poptip>
          </template>
        </Table>
        <Row style="margin-top: 10px">
          <Divider>
            <a v-on:click="addIndexRow" style="font-size: 14px">增加索引</a>
          </Divider>
        </Row>
      </div>
      <a v-on:click="control.foreignKey = !control.foreignKey">
        <Divider orientation="left" dashed>
          <span>外键 </span>
          <Icon :type="control.foreignKey ? 'ios-arrow-down' : 'ios-arrow-forward'" />
        </Divider>
      </a>
      <div v-show="control.foreignKey" class="info-edit-form-content">
        <Table
          ref="foreignKeyTable"
          border
          highlight-row
          size="small"
          :data="table.foreignKey"
          :columns="foreignKey.columns">
          <template slot="name" slot-scope="props">
            <Input v-model="props.row.name" size="small" />
          </template>
          <template slot="column" slot-scope="props">
            <Select v-model="props.row.column" size="small" filterable multiple placeholder="">
              <Option
                v-for="(columnNameItem, columnNameItemIndex) in table.columns"
                v-if="columnNameItem.name"
                :key="'columnNameItemIndex_' + columnNameItemIndex"
                :value="columnNameItem.name">{{ columnNameItem.name }}</Option>
            </Select>
          </template>
          <template slot="referDb" slot-scope="props">
            <Select
              v-model="props.row.referDb"
              size="small"
              filterable
              clearable
              placeholder=""
              @on-change="v => {getTablesDataByReferDb(v, props.idx)}">
              <Option
                v-for="(referDbItem, referDbItemIndex) in callbackdata.databaseList"
                v-if="referDbItem"
                :key="'referDbItemIndex_' + referDbItemIndex"
                :value="referDbItem">{{ referDbItem }}</Option>
            </Select>
          </template>
          <template slot="referTable" slot-scope="props">
            <Select
              v-model="props.row.referTable"
              size="small"
              filterable
              clearable
              placeholder=""
              @on-change="v => {getColumnsByReferTable(v, props.idx)}">
              <Option
                v-for="(referTableItem, referTableItemIndex) in props.row.referTableList"
                v-if="referTableItem"
                :key="'referTableItemIndex_' + referTableItemIndex"
                :value="referTableItem">{{ referTableItem }}</Option>
            </Select>
          </template>
          <template slot="referColumn" slot-scope="props">
            <Select
              v-model="props.row.referColumn"
              size="small"
              filterable
              multiple
              clearable
              placeholder="">
              <Option
                v-for="(referColumnItem, referColumnItemIndex) in props.row.referColumnList"
                v-if="referColumnItem"
                :key="'referColumnItemIndex_' + referColumnItemIndex"
                :value="referColumnItem">{{ referColumnItem }}</Option>
            </Select>
          </template>
          <template slot="deleting" slot-scope="props">
            <Select v-model="props.row.deleting" size="small" placeholder="">
              <Option value="RESTRICT">RESTRICT</Option>
              <Option value="NO ACTION">NO ACTION</Option>
              <Option value="CASCADE">CASCADE</Option>
              <Option value="SET NULL">SET NULL</Option>
            </Select>
          </template>
          <template slot="updating" slot-scope="props">
            <Select v-model="props.row.updating" size="small" placeholder="">
              <Option value="RESTRICT">RESTRICT</Option>
              <Option value="NO ACTION">NO ACTION</Option>
              <Option value="CASCADE">CASCADE</Option>
              <Option value="SET NULL">SET NULL</Option>
            </Select>
          </template>
          <template slot="removeForeignKeyRow" slot-scope="props">
            <Poptip
              transfer
              confirm
              placement="bottom"
              title="确定要移除当前外键吗？"
              @on-ok="removeForeignKeyRow(props.idx)">
              <a>移除</a>
            </Poptip>
          </template>
        </Table>
        <Row style="margin-top: 10px">
          <Divider>
            <a v-on:click="addForeignKeyRow" style="font-size: 14px">增加外键</a>
          </Divider>
        </Row>
      </div>
      <a v-on:click="control.trigger = !control.trigger">
        <Divider orientation="left" dashed>
          <span>触发器 </span>
          <Icon :type="control.trigger ? 'ios-arrow-down' : 'ios-arrow-forward'" />
        </Divider>
      </a>
      <div v-show="control.trigger" class="info-edit-form-content">
        <Table
          ref="triggerTable"
          border
          highlight-row
          size="small"
          :data="table.trigger"
          :columns="trigger.columns">
          <template slot="name" slot-scope="props">
            <Input v-model="props.row.name" size="small" />
          </template>
          <template slot="trigger_time" slot-scope="props">
            <Select v-model="props.row.trigger_time" size="small" placeholder="">
              <Option value="Before">Before</Option>
              <Option value="After">After</Option>
            </Select>
          </template>
          <template slot="insert" slot-scope="props">
            <i-switch v-model="props.row.insert" @on-change="v=>{ changeTriggerMature(v, props.idx, 'insert') }">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </template>
          <template slot="update" slot-scope="props">
            <i-switch v-model="props.row.update" @on-change="v=>{ changeTriggerMature(v, props.idx, 'update') }">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </template>
          <template :slot="'delete'" slot-scope="props">
            <i-switch v-model="props.row.delete" @on-change="v=>{ changeTriggerMature(v, props.idx, 'delete') }">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </template>
          <template slot="statement" slot-scope="props">
              <a v-on:click="writeTriggerStatement(props.row.statement, props.idx)">编辑</a>
          </template>
          <template slot="removeTriggerRow" slot-scope="props">
            <Poptip
              transfer
              confirm
              placement="bottom"
              title="确定要移除当前触发器吗？"
              @on-ok="removeTriggerRow(props.idx)">
              <a>移除</a>
            </Poptip>
          </template>
        </Table>
        <Row style="margin-top: 10px">
          <Divider>
            <a v-on:click="addTriggerRow" style="font-size: 14px">增加触发器</a>
          </Divider>
        </Row>
      </div>
      <div class="info-edit-form-content info-edit-form-button" style="padding: 0;">
        <Button type="primary" @click="ok" :loading="executing">提交</Button>
        <Button type="default" @click="resetForm" style="margin-left: 10px">重置</Button>
      </div>
    </Form>
    <!--<Row style="margin-top: 10px">-->
      <!--<SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>-->
    <!--</Row>-->
    <Modal title="执行结果" v-model="execResultModal" width="1000" footer-hide>
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Modal>
  </div>
</template>

<script>
import { showTableList, showColumnList, createTable, executeSQL, getColumnList, alertTable,
  showCharacterList, showCharacterCollateList } from '@/api/mysql'
import WriteSqlModal from './writeSqlModal'
import SQLResults from './sqlResults'
export default {
  name: 'dbTableEdit',
  components: {
    WriteSqlModal,
    SQLResults
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      table_have_primary: 0,
      table: {
        basis: {
          name: '',
          remark: '',
          storage_engine: 'InnoDB',
          character: 'utf8',
          verify_rule: '',
          row_format: 'DYNAMIC'
        },
        columns: [],
        index: [],
        foreignKey: [],
        trigger: []
      },
      old_table: {},
      executing: false,
      execResultModal: false,
      error: false,
      loading: false,
      // 差异
      diff: {
        basis: {},
        columns: {
          add: [],
          alert: {},
          remove: []
        },
        index: {
          add: [],
          alert: {},
          remove: []
        },
        foreignKey: {
          add: [],
          alert: {},
          remove: []
        },
        trigger: {
          add: [],
          alert: {},
          remove: []
        }
      },
      // 控制表单显示/隐藏
      control: {
        baseInfo: true,
        columnsInfo: true,
        index: false,
        foreignKey: false,
        trigger: false
      },
      // 基本信息
      characterList: [],
      characterCollateList: [],
      // 列信息
      tableCC: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            let com = ''
            switch (params.row.type) {
              case 'tinyint':
              case 'int':
              case 'smallint':
              case 'mediumint':
              case 'integer':
              case 'bigint':
              case 'tinyint unsigned':
              case 'int unsigned':
              case 'smallint unsigned':
              case 'mediumint unsigned':
              case 'integer unsigned':
              case 'bigint unsigned':
                if (!params.row.more || params.row.more.moreType !== params.row.type) {
                  params.row.more = {
                    moreType: params.row.type,
                    auto_increment: false,
                    zerofill: false
                  }
                }
                com = this.$refs.columnsTable.$scopedSlots.type_tinyint({
                  row: params.row,
                  idx: params.row._index
                })
                break
              case 'float':
              case 'float unsigned':
              case 'double':
              case 'double unsigned':
              case 'decimal':
              case 'decimal unsigned':
                if (!params.row.more || params.row.more.moreType !== params.row.type) {
                  params.row.more = {
                    moreType: params.row.type,
                    decimal_point: '',
                    zerofill: false
                  }
                }
                com = this.$refs.columnsTable.$scopedSlots.type_float({
                  row: params.row,
                  idx: params.row._index
                })
                break
              case 'enum':
                if (!params.row.more || params.row.more.moreType !== params.row.type) {
                  params.row.more = {
                    moreType: params.row.type,
                    value: ''
                  }
                }
                com = this.$refs.columnsTable.$scopedSlots.type_enum({
                  row: params.row,
                  idx: params.row._index
                })
                break
              case 'datetime':
              case 'timestamp':
                if (!params.row.more || params.row.more.moreType !== params.row.type) {
                  params.row.more = {
                    moreType: params.row.type,
                    on_update_current_time: false
                  }
                }
                com = this.$refs.columnsTable.$scopedSlots.type_time({
                  row: params.row,
                  idx: params.row._index
                })
                break
            }
            return h('div', com)
          }
        },
        {
          title: '列名',
          key: 'name',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.name({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '类型',
          key: 'type',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.type({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '长度',
          key: 'length',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.length({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '默认值',
          key: 'default',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            let com = 'gen_default'
            if (params.row.type === 'timestamp' || params.row.type === 'datetime') {
              com = 'date_default'
            } else if (params.row.type.substr(params.row.type.length - 4) === 'blob' ||
              params.row.type.substr(params.row.type.length - 4) === 'text') {
              params.row.default = ''
              com = 'dis_default'
            }
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots[com]({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.remark({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '可为空',
          key: 'is_null',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.is_null({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '主键',
          key: 'primary_key',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.primary_key({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        },
        {
          title: '操作',
          key: 'removeColumnField',
          width: 80,
          align: 'center',
          render: (h, params) => {
            this.table.columns[params.index] = params.row
            return h(
              'div',
              this.$refs.columnsTable.$scopedSlots.removeColumnField({
                row: params.row,
                idx: params.row._index
              })
            )
          }
        }
      ],
      tableRule: {
        name: { required: true, message: '表名不能为空', trigger: 'blur' }
      },
      typeList: [
        {
          value: 'tinyint',
          label: 'tinyint'
        },
        {
          value: 'smallint',
          label: 'smallint'
        },
        {
          value: 'mediumint',
          label: 'mediumint'
        },
        {
          value: 'int',
          label: 'int'
        },
        {
          value: 'integer',
          label: 'integer'
        },
        {
          value: 'bigint',
          label: 'bigint'
        },
        {
          value: 'tinyint unsigned',
          label: 'tinyint unsigned'
        },
        {
          value: 'smallint unsigned',
          label: 'smallint unsigned'
        },
        {
          value: 'mediumint unsigned',
          label: 'mediumint unsigned'
        },
        {
          value: 'int unsigned',
          label: 'int unsigned'
        },
        {
          value: 'integer unsigned',
          label: 'integer unsigned'
        },
        {
          value: 'bigint unsigned',
          label: 'bigint unsigned'
        },
        {
          value: 'bit',
          label: 'bit'
        },
        {
          value: 'double',
          label: 'double'
        },
        {
          value: 'float',
          label: 'float'
        },
        {
          value: 'decimal',
          label: 'decimal'
        },
        {
          value: 'double unsigned',
          label: 'double unsigned'
        },
        {
          value: 'float unsigned',
          label: 'float unsigned'
        },
        {
          value: 'decimal unsigned',
          label: 'decimal unsigned'
        },
        {
          value: 'char',
          label: 'char'
        },
        {
          value: 'varchar',
          label: 'varchar'
        },
        {
          value: 'date',
          label: 'date'
        },
        {
          value: 'time',
          label: 'time'
        },
        {
          value: 'timestamp',
          label: 'timestamp'
        },
        {
          value: 'year',
          label: 'year'
        },
        {
          value: 'datetime',
          label: 'datetime'
        },
        {
          value: 'tinyblob',
          label: 'tinyblob'
        },
        {
          value: 'blob',
          label: 'blob'
        },
        {
          value: 'mediumblob',
          label: 'mediumblob'
        },
        {
          value: 'longblob',
          label: 'longblob'
        },
        {
          value: 'tinytext',
          label: 'tinytext'
        },
        {
          value: 'text',
          label: 'text'
        },
        {
          value: 'mediumtext',
          label: 'mediumtext'
        },
        {
          value: 'longtext',
          label: 'longtext'
        },
        {
          value: 'enum',
          label: 'enum'
        },
        {
          value: 'json',
          label: 'json'
        }
      ],
      storage_engine_list: [
        {
          value: 'MRG_MYISAM',
          label: 'MRG_MYISAM'
        },
        {
          value: 'CSV',
          label: 'CSV'
        },
        {
          value: 'MyISAM',
          label: 'MyISAM'
        },
        {
          value: 'BLACKHOLE',
          label: 'BLACKHOLE'
        },
        {
          value: 'MEMORY',
          label: 'MEMORY'
        },
        {
          value: 'InnoDB',
          label: 'InnoDB'
        },
        {
          value: 'ARCHIVE',
          label: 'ARCHIVE'
        }
      ],
      row_format_list: [
        {
          value: 'COMPACT',
          label: 'COMPACT'
        },
        {
          value: 'COMPRESSED',
          label: 'COMPRESSED'
        },
        {
          value: 'DEFAULT',
          label: 'DEFAULT'
        },
        {
          value: 'DYNAMIC',
          label: 'DYNAMIC'
        },
        {
          value: 'FIXED',
          label: 'FIXED'
        },
        {
          value: 'REDUNDANT',
          label: 'REDUNDANT'
        }
      ],
      currentColumnIndex: '',
      enumValues: [],
      enumValueModal: false,
      // 索引
      index: {
        columns: [
          {
            title: '索引名',
            key: 'name',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.index[params.index] = params.row
              return h(
                'div',
                this.$refs.indexTable.$scopedSlots.name({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '包含列',
            key: 'columns',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.index[params.index] = params.row
              return h(
                'div',
                this.$refs.indexTable.$scopedSlots.columns({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '索引类型',
            key: 'type',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.index[params.index] = params.row
              return h(
                'div',
                this.$refs.indexTable.$scopedSlots.type({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '索引方法',
            key: 'func',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.index[params.index] = params.row
              return h(
                'div',
                this.$refs.indexTable.$scopedSlots.func({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '操作',
            key: 'removeIndexRow',
            width: 80,
            align: 'center',
            render: (h, params) => {
              this.table.index[params.index] = params.row
              return h(
                'div',
                this.$refs.indexTable.$scopedSlots.removeIndexRow({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          }
        ]
      },
      indexHaveColumns: [],
      currentIndexIdx: '',
      indexHaveColumnsModal: false,
      // 外键
      foreignKey: {
        columns: [
          {
            title: '外键名',
            key: 'name',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.name({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '列',
            key: 'column',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.column({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '参考数据库',
            key: 'referDb',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.referDb({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '参考表',
            key: 'referTable',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.referTable({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '参考列',
            key: 'referColumn',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.referColumn({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '删除时',
            key: 'deleting',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.deleting({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '更新时',
            key: 'updating',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.updating({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '操作',
            key: 'removeForeignKeyRow',
            width: 80,
            align: 'center',
            render: (h, params) => {
              this.table.foreignKey[params.index] = params.row
              return h(
                'div',
                this.$refs.foreignKeyTable.$scopedSlots.removeForeignKeyRow({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          }
        ]
      },
      // 触发器
      trigger: {
        columns: [
          {
            title: '触发器名',
            key: 'name',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.name({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '触发',
            key: 'trigger_time',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.trigger_time({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '插入',
            key: 'insert',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.insert({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '更新',
            key: 'update',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.update({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '删除',
            key: 'delete',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.delete({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '定义',
            key: 'statement',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.statement({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          },
          {
            title: '操作',
            key: 'removeTriggerRow',
            width: 80,
            align: 'center',
            render: (h, params) => {
              this.table.trigger[params.index] = params.row
              return h(
                'div',
                this.$refs.triggerTable.$scopedSlots.removeTriggerRow({
                  row: params.row,
                  idx: params.row._index
                })
              )
            }
          }
        ]
      },
      currentTriggerIdx: ''
    }
  },
  created: function () {
    this.getCharacterListByInstanceId()
    if (this.callbackdata.table) {
      this.init()
    } else {
      this.getCharacterCollateListByCharacter(this.table.basis.character, true)
    }
  },
  mounted: function () {
    if (!this.callbackdata.table) {
      this.addColumnField()
    }
  },
  methods: {
    // 编辑表初始化数据
    init () {
      let params = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        table: this.callbackdata.table
      }
      this.loading = true
      this.error = false
      getColumnList(params).then(res => {
        const result = res.data
        // 基础信息
        this.table_have_primary = result.base_table[0].have_primary
        this.table.basis.name = result.base_table[0].table_name
        this.table.basis.storage_engine = result.base_table[0].engine
        this.table.basis.row_format = result.base_table[0].row_format
        this.table.basis.character = result.base_table[0].table_character
        this.table.basis.verify_rule = result.base_table[0].table_collation
        this.table.basis.remark = result.base_table[0].table_comment
        this.getCharacterCollateListByCharacter(this.table.basis.character)
        // 列信息
        for (let i in result.columns) {
          let columnInfo = result.columns[i]
          let data = {
            name: columnInfo.column_name,
            type: columnInfo.data_type,
            length: columnInfo.length,
            default: columnInfo.column_default,
            remark: columnInfo.column_comment,
            is_null: !!columnInfo.is_null,
            primary_key: !!columnInfo.is_primary,
            more: {
              decimal_point: columnInfo.numeric_scale,
              auto_increment: !!columnInfo.is_auto_increment,
              zerofill: !!columnInfo.is_zerofill,
              on_update_current_time: !!columnInfo.is_on_update_current_time,
              value: columnInfo.enum_value
            }
          }
          if (columnInfo.is_unsigned) {
            data.type += ' unsigned'
          }
          data.more.moreType = data.type
          this.table.columns.push(data)
        }
        // 索引
        for (let i in result.indexes) {
          let indexInfo = result.indexes[i]
          let data = {
            name: indexInfo.index_name,
            columns: indexInfo.columns,
            type: indexInfo.index_type,
            func: indexInfo.index_method
          }
          this.table.index.push(data)
        }
        // 外键
        for (let i in result.references) {
          let referenceInfo = result.references[i]
          let data = {
            name: referenceInfo.constraint_name,
            column: (referenceInfo.column_name).split(','),
            referDb: referenceInfo.referenced_table_schema,
            referTableList: [],
            referTable: referenceInfo.referenced_table_name,
            referColumnList: [],
            referColumn: (referenceInfo.referenced_column_name).split(','),
            deleting: referenceInfo.DELETE_RULE,
            updating: referenceInfo.UPDATE_RULE
          }
          this.table.foreignKey.push(data)
          let params = {
            db: referenceInfo.referenced_table_schema,
            id: this.callbackdata.instance_id
          }
          showTableList(params).then(res => {
            data.referTableList = res.data.results
            this.table.foreignKey.splice(i, 1, data)
          })
          let params2 = {
            table: referenceInfo.referenced_table_name,
            db: referenceInfo.referenced_table_schema,
            id: this.callbackdata.instance_id
          }
          showColumnList(params2).then(res => {
            data.referColumnList = res.data.results
            this.table.foreignKey.splice(i, 1, data)
          })
        }
        // 触发器
        for (let i in result.triggers) {
          let triggerInfo = result.triggers[i]
          let data = {
            name: triggerInfo.trigger_name,
            trigger_time: triggerInfo.action_timing === 'BEFORE' ? 'Before' : 'After',
            insert: triggerInfo.event_manipulation === 'INSERT',
            update: triggerInfo.event_manipulation === 'UPDATE',
            delete: triggerInfo.event_manipulation === 'DELETE',
            statement: triggerInfo.action_statement
          }
          this.table.trigger.push(data)
        }
        this.loading = false
        this.old_table = JSON.parse(JSON.stringify(this.table))
      }).catch(res => {
        this.error = true
        this.loading = false
      })
    },
    // 提交表单
    ok () {
      if (this.callbackdata.table) {
        let isGlobalDiff = false
        // 对比基础信息
        this.diff.basis = {}
        for (let i in this.table.basis) {
          if (this.table.basis[i] !== this.old_table.basis[i]) {
            this.diff.basis[i] = {
              old: this.old_table.basis[i],
              new: this.table.basis[i]
            }
            isGlobalDiff = true
          }
        }
        // 对比列信息
        this.diff.columns.add = []
        this.diff.columns.alert = []
        if (this.diff.columns.remove.length) {
          isGlobalDiff = true
        }
        for (let i in this.table.columns) {
          if (this.table.columns[i].new) {
            isGlobalDiff = true
            this.diff.columns.add.push(this.table.columns[i])
          } else {
            let isDiff = false
            for (let x in this.table.columns[i]) {
              if (this.table.columns[i][x] !== this.old_table.columns[i][x]) {
                if (x.substring(0, 1) === '_') {
                  continue
                } else if (x === 'more') {
                  for (let c in this.table.columns[i][x]) {
                    if (this.table.columns[i][x][c] !== this.old_table.columns[i][x][c]) {
                      isDiff = true
                      break
                    }
                  }
                } else {
                  if (!this.table.columns[i][x] && !this.old_table.columns[i][x]) {
                    continue
                  }
                  isDiff = true
                  break
                }
              }
            }
            if (isDiff) {
              isGlobalDiff = true
              let alertDiff = this.table.columns[i]
              alertDiff._old_name = this.old_table.columns[i].name
              // this.diff.columns.alert[this.old_table.columns[i].name] = this.table.columns[i]
              this.diff.columns.alert.push(alertDiff)
            }
          }
        }
        // 对比索引, 外键, 触发器
        let gn = ['index', 'foreignKey', 'trigger']
        for (let g in gn) {
          if (this.diff[gn[g]].remove.length) {
            isGlobalDiff = true
          }
          this.diff[gn[g]].add = []
          this.diff[gn[g]].alert = []
          for (let i in this.table[gn[g]]) {
            if (this.table[gn[g]][i].new) {
              isGlobalDiff = true
              this.diff[gn[g]].add.push(this.table[gn[g]][i])
            } else {
              let isDiff = false
              for (let x in this.table[gn[g]][i]) {
                if (this.table[gn[g]][i][x] !== this.old_table[gn[g]][i][x]) {
                  if (x !== 'referTableList' && x !== 'referColumnList' && x.substring(0, 1) !== '_') {
                    if (gn[g] === 'foreignKey') {
                      if (x === 'column' || x === 'referColumn') {
                        if (this.table[gn[g]][i][x].length !== this.old_table[gn[g]][i][x].length) {
                          isDiff = true
                          break
                        }
                        for (let mn in this.table[gn[g]][i][x]) {
                          if (this.table[gn[g]][i][x][mn] !== this.old_table[gn[g]][i][x][mn]) {
                            isDiff = true
                            break
                          }
                        }
                      } else {
                        isDiff = true
                        break
                      }
                    } else {
                      isDiff = true
                      break
                    }
                  }
                }
              }
              if (isDiff) {
                isGlobalDiff = true
                let alertDiff = this.table[gn[g]][i]
                alertDiff._old_name = this.old_table[gn[g]][i].name
                // this.diff[gn[g]].alert[this.old_table[gn[g]][i].name] = this.table[gn[g]][i]
                this.diff[gn[g]].alert.push(alertDiff)
              }
            }
          }
        }
        if (isGlobalDiff) {
          alertTable({ diff: this.diff, table: this.callbackdata.table, 'have_primary': this.table_have_primary }).then(res => {
            this.$Notice.success({
              title: '请检查SQL，点击确认提交！'
            })
            this.$refs.WriteSqlModal.open(res.data.sql, 'table')
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '失败',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '提交失败'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '没有任何修改！'
          })
        }
      } else {
        createTable(this.table).then(res => {
          this.$refs.WriteSqlModal.open(res.data.sql, 'table')
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '失败',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '提交失败'
            })
          }
        })
      }
    },
    // 开始执行SQL
    CreateTableSqlComplete (sql) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: '100'
      }
      let that = this
      that.executing = true
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          if (item['success']) {
            that.$Notice.success({
              title: '操作成功',
              desc: item['msg']
            })
            if (!that.callbackdata.table) {
              let pushData = {
                tab_id: that.callbackdata.id,
                db: that.callbackdata.db,
                table: that.table.basis.name
              }
              that.$emit('callBack', 'createTableSuccess', pushData)
            } else {
              that.callbackdata.table = that.table.basis.name
              that.resetForm()
            }
          } else {
            that.$Notice.error({
              title: item['msg']
            })
          }
          results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
          that.execResultModal = true
        })
        that.executing = false
        that.$refs.SQLResults.showResult(results)
      }).catch(res => {
        that.executing = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 重置表单
    resetForm () {
      this.table = {
        basis: {
          name: '',
          remark: '',
          storage_engine: 'InnoDB',
          character: 'utf8',
          verify_rule: '',
          row_format: 'DYNAMIC'
        },
        columns: [],
        index: [],
        foreignKey: [],
        trigger: []
      }
      if (this.callbackdata.table) {
        this.init()
        this.diff = {
          basis: {},
          columns: {
            add: [],
            alert: {},
            remove: []
          },
          index: {
            add: [],
            alert: {},
            remove: []
          },
          foreignKey: {
            add: [],
            alert: {},
            remove: []
          },
          trigger: {
            add: [],
            alert: {},
            remove: []
          }
        }
      } else {
        this.addColumnField()
        this.getCharacterCollateListByCharacter(this.table.basis.character, true)
      }
    },

    // 基本信息
    // 基本信息 - 获取根据实例ID字符集列表
    getCharacterListByInstanceId () {
      showCharacterList({ id: this.callbackdata.instance_id }).then(res => {
        this.characterList = res.data.results
      })
    },
    // 基本信息 - 获取根据字符集获取校验规则列表
    getCharacterCollateListByCharacter (character, change = false) {
      showCharacterCollateList({ id: this.callbackdata.instance_id, character: character }).then(res => {
        this.characterCollateList = res.data.results
        if (change && this.characterCollateList.length) {
          this.table.basis.verify_rule = this.characterCollateList[0]
        }
      })
    },

    // 列信息
    // 列信息 - 增加列
    addColumnField () {
      this.table.columns.push({
        name: '',
        type: '',
        length: '',
        default: '',
        remark: '',
        is_null: false,
        primary_key: false,
        _expanded: true,
        new: true
      })
    },
    // 列信息 - 移除列
    removeColumnField (index) {
      if (!this.table.columns[index].new) {
        this.diff.columns.remove.push(this.old_table.columns[index].name)
        this.old_table.columns.splice(index, 1)
      }
      this.table.columns.splice(index, 1)
    },
    // 列信息 - 修改主键开关触发
    primarySwitch (status, index) {
      if (status) {
        this.table.columns[index].is_null = false
      }
    },
    // 列信息 - 打开编辑枚举值模态框
    openEnumModal (index) {
      let value = this.table.columns[index].more.value
      this.enumValues = []
      if (value) {
        let valueList = value.split(',')
        for (let i in valueList) {
          let m = valueList[i]
          if (m) {
            m.replace(new RegExp('^\\' + '\'' + '+|\\' + '\'' + '+$', 'g'), '')
            this.addEnumValue(m.trim('\''))
          }
        }
      } else {
        this.addEnumValue()
      }
      this.currentColumnIndex = index
      this.enumValueModal = true
    },
    // 列信息 - 增加枚举值
    addEnumValue (value = '') {
      this.enumValues.push(
        {
          value: value
        }
      )
    },
    // 列信息 - 移除枚举值
    removeEnumValue (index) {
      this.enumValues.splice(index, 1)
    },
    // 列信息 - 关闭编辑枚举值模态框
    enumValueModalCancel () {
      this.enumValues = [
        {
          value: ''
        }
      ]
    },
    // 列信息 - 枚举值模态框点击完成触发
    enumValueOk () {
      let enumList = []
      for (let i in this.enumValues) {
        enumList.push('\'' + this.enumValues[i].value + '\'')
      }
      let oldCo = this.table.columns[this.currentColumnIndex]
      oldCo.more = {
        moreType: 'enum',
        value: enumList.join(',')
      }
      this.table.columns.splice(this.currentColumnIndex, 1, oldCo)
      this.table.columns[this.currentColumnIndex]._expanded = true
      this.enumValueModalCancel()
    },

    // 索引
    // 索引 - 增加索引
    addIndexRow () {
      this.table.index.push({
        name: '',
        columns: '',
        type: 'Normal',
        func: 'BTREE',
        new: true
      })
    },
    // 索引 - 移除索引
    removeIndexRow (index) {
      if (!this.table.index[index].new) {
        this.diff.index.remove.push(this.old_table.index[index].name)
        this.old_table.index.splice(index, 1)
      }
      this.table.index.splice(index, 1)
    },
    // 索引 -  增加索引包含列
    addIndexHaveColumn (column = '', son = '') {
      this.indexHaveColumns.push(
        {
          column: column,
          son: son
        }
      )
    },
    // 索引 - 移除索引包含列
    removeIndexHaveColumn (index) {
      this.indexHaveColumns.splice(index, 1)
    },
    // 索引 - 编辑索引包含列完成
    indexHaveColumnsOk () {
      let cList = []
      for (let i in this.indexHaveColumns) {
        let addValue = this.indexHaveColumns[i].column
        if (this.indexHaveColumns[i].son) {
          addValue += ('(' + this.indexHaveColumns[i].son + ')')
        }
        cList.push(addValue)
      }
      let oldCo = this.table.index[this.currentIndexIdx]
      oldCo.columns = cList.join(',')
      this.table.index.splice(this.currentIndexIdx, 1, oldCo)
      this.indexHaveColumnsModalCancel()
    },
    // 索引 - 打开编辑索引包含列模态框
    openIndexHaveColumnsModal (index) {
      let value = this.table.index[index].columns
      this.indexHaveColumns = []
      if (value) {
        let valueList = value.split(',')
        for (let i in valueList) {
          let m = valueList[i]
          if (m) {
            let columnsSeparate = m.split('(')
            if (columnsSeparate.length > 1) {
              this.addIndexHaveColumn(columnsSeparate[0], columnsSeparate[columnsSeparate.length - 1].split(')')[0])
            } else {
              this.addIndexHaveColumn(columnsSeparate[0])
            }
          }
        }
      } else {
        this.addIndexHaveColumn()
      }
      this.currentIndexIdx = index
      this.indexHaveColumnsModal = true
    },
    // 索引 - 关闭编辑索引包含列模态框
    indexHaveColumnsModalCancel () {
      this.enumValues = [
        {
          column: '',
          son: ''
        }
      ]
    },

    // 外键
    // 外键 - 增加外键
    addForeignKeyRow () {
      this.table.foreignKey.push({
        name: '',
        column: [],
        referDb: '',
        referTableList: [],
        referTable: '',
        referColumnList: [],
        referColumn: [],
        deleting: 'RESTRICT',
        updating: 'RESTRICT',
        new: true
      })
    },
    // 外键 - 移除外键
    removeForeignKeyRow (index) {
      if (!this.table.foreignKey[index].new) {
        this.diff.foreignKey.remove.push(this.old_table.foreignKey[index].name)
        this.old_table.foreignKey.splice(index, 1)
      }
      this.table.foreignKey.splice(index, 1)
    },
    // 外键 - 根据参考数据库获取参考表列表
    getTablesDataByReferDb (db, index) {
      let oldData = this.table.foreignKey[index]
      oldData.referTable = ''
      oldData.referColumn = []
      oldData.referColumnList = []
      let params = {
        db: db,
        id: this.callbackdata.instance_id
      }
      showTableList(params).then(res => {
        oldData.referTableList = res.data.results
        this.table.foreignKey.splice(index, 1, oldData)
      })
    },
    // 外键 - 根据参考表获取参考列
    getColumnsByReferTable (tableName, index) {
      let oldData = this.table.foreignKey[index]
      oldData.referColumn = []
      let params = {
        table: tableName,
        db: oldData.referDb,
        id: this.callbackdata.instance_id
      }
      showColumnList(params).then(res => {
        oldData.referColumnList = res.data.results
        this.table.foreignKey.splice(index, 1, oldData)
      })
    },

    // 触发器
    // 触发器 - 增加触发器
    addTriggerRow () {
      this.table.trigger.push({
        name: '',
        trigger_time: 'Before',
        insert: false,
        update: false,
        delete: false,
        statement: '',
        new: true
      })
    },
    // 触发器 - 移除触发器
    removeTriggerRow (index) {
      if (!this.table.trigger[index].new) {
        this.diff.trigger.remove.push(this.old_table.trigger[index].name)
        this.old_table.trigger.splice(index, 1)
      }
      this.table.trigger.splice(index, 1)
    },
    // 触发器 - 修改触发时机开关时触发
    changeTriggerMature (status, index, mature) {
      if (status) {
        switch (mature) {
          case 'insert':
            this.table.trigger[index].update = false
            this.table.trigger[index].delete = false
            break
          case 'update':
            this.table.trigger[index].insert = false
            this.table.trigger[index].delete = false
            break
          case 'delete':
            this.table.trigger[index].insert = false
            this.table.trigger[index].update = false
            break
        }
      }
    },
    // 触发器 - 打开编辑触发器定义模态框
    writeTriggerStatement (statement, index) {
      this.currentTriggerIdx = index
      this.$refs.WriteSqlModal.open(statement, 'trigger')
    },
    // 触发器 - 编辑定义完成后保存
    writeSQLComplete (statement, type) {
      if (type === 'trigger') {
        this.table.trigger[this.currentTriggerIdx].statement = statement
      } else {
        this.CreateTableSqlComplete(statement)
      }
    }
  }
}
</script>

<style>
  #indexTable .ivu-input-disabled {
    background-color: #ffffff;
    color: #515a6e;
  }
  #indexTable .ivu-input-group-with-append {
    border-bottom: 1px solid #dcdee2;
  }
  #db-table-edit .info-edit-form-content {
    background-color: #F5F7F9;
    padding: 20px 5px 0 5px;
  }
  #db-table-edit .info-edit-form-button {
    text-align: center;
    height: 100px;
    display: block;
    line-height: 100px;
    margin-top: 10px;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
</style>
